import Provider from "../models/Provider";
import WSReader from "../rocket/WSReader";
import Admin from "../models/Admin";
import AdminSignUpRequest from "../models/AdminSignUpRequest";
import Business from "../models/Business";
import MessageDispatch from "../rocket/MessageDispatch";
import { RPCConstants } from "../rocket/D3ETemplate";

export default class UniqueCheckerClient {
  public async checkEmailUniqueInAdmin(
    admin: Admin,
    email: string
  ): Promise<boolean> {
    let r: WSReader = await MessageDispatch.get().rpcMessage(
      RPCConstants.UniqueChecker,
      RPCConstants.UniqueCheckerCheckEmailUniqueInAdmin,
      {
        "args": (w) => {
          w.writeObjFull(admin);

          w.writeString(email);
        },
      }
    );

    let code: number = r.readByte();

    if (code === 1) {
      let error: string = r.readString();

      return Promise.error(error);
    }

    return r.readBoolean() as boolean;
  }
  public async checkEmailUniqueInAdminSignUpRequest(
    adminSignUpRequest: AdminSignUpRequest,
    email: string
  ): Promise<boolean> {
    let r: WSReader = await MessageDispatch.get().rpcMessage(
      RPCConstants.UniqueChecker,
      RPCConstants.UniqueCheckerCheckEmailUniqueInAdminSignUpRequest,
      {
        "args": (w) => {
          w.writeObjFull(adminSignUpRequest);

          w.writeString(email);
        },
      }
    );

    let code: number = r.readByte();

    if (code === 1) {
      let error: string = r.readString();

      return Promise.error(error);
    }

    return r.readBoolean() as boolean;
  }
  public async checkProviderEmailUniqueInBusiness(
    business: Business,
    provider: Provider,
    email: string
  ): Promise<boolean> {
    let r: WSReader = await MessageDispatch.get().rpcMessage(
      RPCConstants.UniqueChecker,
      RPCConstants.UniqueCheckerCheckProviderEmailUniqueInBusiness,
      {
        "args": (w) => {
          w.writeObjFull(business);

          w.writeObjFull(provider);

          w.writeString(email);
        },
      }
    );

    let code: number = r.readByte();

    if (code === 1) {
      let error: string = r.readString();

      return Promise.error(error);
    }

    return r.readBoolean() as boolean;
  }
}
